import { Outlet, useLocation } from "react-router-dom";
import { BottomTabs } from "./BottomTabs";
import { DesktopSidebar } from "./DesktopSidebar";
import { PatientSwitcher } from "./PatientSwitcher";
import { NotificationBell } from "@/components/notifications/NotificationBell";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { useIsMobile } from "@/hooks/use-mobile";

const PUBLIC_ROUTES = ["/login", "/signup", "/forgot-password", "/reset-password", "/change-password", "/onboarding", "/emergency", "/carer-onboarding"];

export function AppLayout() {
  const isMobile = useIsMobile();
  const location = useLocation();
  const isPublicRoute = PUBLIC_ROUTES.includes(location.pathname);

  if (isPublicRoute) {
    return <main id="main-content" className="min-h-screen"><ErrorBoundary><Outlet /></ErrorBoundary></main>;
  }

  return (
    <div className="flex min-h-screen">
      {!isMobile && <DesktopSidebar />}
      <main id="main-content" className={`flex-1 flex flex-col ${isMobile ? "pb-20" : ""}`}>
        <div className="flex items-center justify-between gap-2 px-4 py-2 border-b bg-background sticky top-0 z-40">
          <PatientSwitcher />
          <div className="ml-auto flex items-center gap-2">
            <NotificationBell />
          </div>
        </div>
        <div className="flex-1">
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </main>
      {isMobile && <BottomTabs />}
    </div>
  );
}
